import { Modal } from 'react-bootstrap';
import { ReactNode } from 'react';

type ModalFooterProps = {
    children: ReactNode;
};
const ModalFooter = ({ children }: ModalFooterProps) => <Modal.Footer className="border-0">{children}</Modal.Footer>;

export default ModalFooter;
